import type { BasicListOption } from '../GenericBloc/GenericLargeListFilter/GenericLargeListType';

export enum GenericOccurredOperation {
  OCCURRED = 'occurred',
  DID_NOT_OCCUR = 'did_not_occur',
}

export const GENERIC_OCCURRED_OPTION_LIST: BasicListOption<GenericOccurredOperation>[] = [
  { value: GenericOccurredOperation.OCCURRED, label: 'occurred' },
  { value: GenericOccurredOperation.DID_NOT_OCCUR, label: 'did not occur' },
];
